import React from 'react';

export function Loading() {
  return <> Loading .... </>;
}
